module.exports = __webpack_public_path__ + "img/1.4d73228d.png";